<script setup>
import { ref, watch } from "vue"
import Swal from "sweetalert2"
import api from "@/api/axios.js"

const props = defineProps({
  visible: Boolean,
  citaId: { type: [Number, String], default: null }
})

defineEmits(["close"])

const LABELS_ACCION = {
  creada: "Cita creada",
  editada: "Datos editados",
  estado: "Cambio de estado"
}

const ICONO_ACCION = {
  creada: "bi-plus-circle text-success",
  editada: "bi-pencil text-primary",
  estado: "bi-arrow-repeat text-info"
}

const historial = ref([])
const cargando = ref(false)

async function cargar() {
  if (!props.citaId) return
  cargando.value = true
  try {
    const { data } = await api.get(`/citas/${props.citaId}/historial`)
    historial.value = data.historial
  } catch (err) {
    Swal.fire({
      icon: "error",
      title: "No se pudo cargar el historial",
      text: err.response?.data?.error || "Error de conexión con el servidor."
    })
  } finally {
    cargando.value = false
  }
}

watch(() => [props.visible, props.citaId], ([visible]) => {
  if (visible) cargar()
})

function formatFechaHora(value) {
  if (!value) return ""
  return new Date(value).toLocaleString("es-CO", { dateStyle: "medium", timeStyle: "short" })
}
</script>

<template>
  <template v-if="visible">
    <div class="modal-backdrop-custom" @click="$emit('close')"></div>
    <div class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"><i class="bi bi-clock-history text-primary me-2"></i>Historial de la cita</h5>
            <button class="btn-close" @click="$emit('close')"></button>
          </div>

          <div class="modal-body">
            <div v-if="cargando" class="text-center text-muted py-4">
              <div class="spinner-border spinner-border-sm me-2" role="status"></div>
              Cargando historial...
            </div>
            <div v-else-if="historial.length === 0" class="text-muted text-sm py-3 text-center">
              No hay movimientos registrados.
            </div>
            <ul v-else class="list-group list-group-flush">
              <li v-for="h in historial" :key="h.id" class="list-group-item px-0">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <p class="mb-0 text-sm font-weight-bold">
                      <i class="bi me-1" :class="ICONO_ACCION[h.accion] || 'bi-dot'"></i>
                      {{ LABELS_ACCION[h.accion] || h.accion }}
                    </p>
                    <p class="mb-0 text-sm">{{ h.detalle }}</p>
                  </div>
                </div>
                <p class="mb-0 text-xs text-muted mt-1">
                  {{ h.usuarioNombre || "Usuario eliminado" }} · {{ formatFechaHora(h.createdAt) }}
                </p>
              </li>
            </ul>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary mb-0" @click="$emit('close')">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<style scoped>
.modal-backdrop-custom {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1040;
}

.modal {
  z-index: 1050;
}
</style>
